// extracted by mini-css-extract-plugin
module.exports = {"introduccioObservador":"IntroduccioObservadorNoAdmin_introduccioObservador__2KyCe"};